export enum pSatzModel {
  SINGULAR = "P-Satz",
  PLURAL = "P-Sätze",
  ICON = "mdi-alpha-p-box",
  ITEM_KEY = "psatz",
  ITEM_KEY_UPDATE = "psaetze",
}
